import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';
import { useCart } from '../../context/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const [isAdding, setIsAdding] = useState(false);

  const handleAdd = () => {
    setIsAdding(true);
    addToCart(product);
    setTimeout(() => setIsAdding(false), 1000);
  };

  return (
    <motion.div 
      whileHover={{ y: -12 }}
      className="group bg-white rounded-[2.5rem] overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-frost-ice/50 flex flex-col h-full"
    >
      <div className="relative aspect-[4/5] overflow-hidden">
        {product.tag && (
          <div className="absolute top-6 left-6 z-20 bg-frost-berry text-white text-[10px] font-black px-4 py-2 rounded-full uppercase tracking-[0.2em] shadow-lg">
            {product.tag}
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-frost-dark/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10"></div>
        <img 
          src={product.image} 
          alt={product.name} 
          className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-1000"
          loading="lazy"
        />
        
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 w-[80%] opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
          <button 
            onClick={handleAdd}
            disabled={isAdding}
            className="w-full bg-white text-frost-berry py-3 rounded-2xl font-bold flex items-center justify-center gap-2 shadow-xl hover:bg-frost-ice active:scale-95 transition-all"
          >
            {isAdding ? <SafeIcon icon="FiCheck" className="text-green-500" /> : <SafeIcon icon="FiPlus" />}
            {isAdding ? 'Added to Box' : 'Quick Add'}
          </button>
        </div>
      </div>
      
      <div className="p-8 flex flex-col flex-grow">
        <div className="flex justify-between items-start mb-4">
          <div className="flex-grow pr-2">
            <div className="text-[10px] font-black text-frost-berry-light uppercase tracking-widest mb-1">
              {product.type}
            </div>
            <h3 className="text-xl font-bold group-hover:text-frost-berry transition-colors duration-300 line-clamp-1">{product.name}</h3>
          </div>
          <span className="text-xl font-serif font-black text-frost-berry shrink-0">
            ${product.price}
          </span>
        </div>
        
        <p className="text-gray-500 text-sm leading-relaxed mb-6 line-clamp-2 italic flex-grow">
          {product.description}
        </p>

        <div className="space-y-4 pt-4 border-t border-frost-ice">
          <div className="flex items-center justify-between text-[10px] font-bold text-gray-400 uppercase tracking-widest">
            <div className="flex items-center gap-2">
              <SafeIcon icon="FiBox" className="text-frost-berry" />
              <span>In Stock: {product.stock}</span>
            </div>
            <div className="flex items-center gap-1 text-frost-berry-light">
              <SafeIcon icon="FiClock" />
              <span>Ships Monday</span>
            </div>
          </div>
          
          <button 
            onClick={handleAdd}
            className="md:hidden w-full btn-primary !py-3 !text-sm flex items-center justify-center gap-2"
          >
            Add to Box
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;